import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function ProcessComplete(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      sx,
      viewBox,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "ProcessComplete",
      children: [
        /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.light, d: "M5.636 10H43.38v23.725H5.636V10Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: theme.vars.palette.secondary.main,
            d: "M7.88 13.2a1 1 0 0 1 1-1h31.001a1 1 0 0 1 1 1v15.6a1 1 0 0 1-1 1h-31a1 1 0 0 1-1-1V13.2Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: theme.vars.palette.primary.dark,
            d: "M3.48 32h41.8v1.1a4.4 4.4 0 0 1-4.4 4.4h-33a4.4 4.4 0 0 1-4.4-4.4V32Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M19.979 33.1h8.8v2.2h-8.8v-2.2Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: theme.vars.palette.primary.light,
            d: "M28.97 28.333h-7.843c-.834 0-1.47-.7-1.47-1.617s.636-1.618 1.47-1.618h7.843c.833 0 1.47.7 1.47 1.617s-.637 1.618-1.47 1.618Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: theme.vars.palette.primary.dark,
            d: "M25.05 24.02a5.392 5.392 0 1 0 0-10.785 5.392 5.392 0 0 0 0 10.785Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: theme.vars.palette.secondary.main,
            d: "M24.375 21.997a.612.612 0 0 1-.472-.202l-2.022-2.022a.652.652 0 0 1 0-.943c.27-.27.674-.27.944 0l1.415 1.415 2.898-4.65c.202-.338.607-.405.944-.203.337.202.404.607.202.944l-3.37 5.392c-.135.202-.27.27-.472.337 0-.068-.067-.068-.067-.068Z"
          }
        )
      ]
    }
  );
}
ProcessComplete.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "ProcessComplete"
};
validateTidalLicense();
export {
  ProcessComplete
};
//# sourceMappingURL=ProcessComplete.js.map
